<template>
  <b-modal
    :id="modalId"
    :title="title"
    @hidden="reset"
    hide-footer
    no-close-on-backdrop
  >
    <b-tabs content-class="mt-3" v-if="selectedProduct">
      <b-tab title="New Version">
        <div v-if="newVersionSuccess" class="alert alert-success" role="alert">
          Success! New version has been created.
        </div>
        <version-form :product="selectedProduct" @hasUpdate="newVersion" />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import VersionForm from "../Forms/VersionForm.vue";
import config from "../../constants/config";
import { mapGetters } from "vuex";

export default {
  name: "VersionModal",
  components: {
    VersionForm
  },
  data() {
    return {
      newVersionSuccess: false
    };
  },
  methods: {
    newVersion() {
      this.newVersionSuccess = true;
      this.$emit("hasUpdate");
    },
    reset() {
      this.newVersionSuccess = false;
    }
  },
  computed: {
    ...mapGetters("product", ["selectedProduct"]),
    modalId() {
      return config.PRODUCT_MODAL_ID;
    },
    title() {
      return this.selectedProduct ? this.selectedProduct.name : "";
    }
  }
};
</script>
